import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SNModalService } from '@web-services/modal/snModal.service';
import { MessageService } from '@services/helpers/message-service/message.service';
import { SubscriptionEstimate } from '@models/subscription.model';
import { takeUntil } from 'rxjs/operators';
import { NewSubscriptionServiceDataProvider } from '@services/subscription/subscription.service';
import { Subject } from 'rxjs/Subject';

@Component({
	selector: 'cancel-subscription-confirm-modal',
	template: require('./cancel-subscription-confirm-modal.html'),
	styles: [require('./cancel-subscription-confirm-modal.scss')]
})
export class CancelSubscriptionConfirmModalComponent
	implements OnInit, OnDestroy {
	@Input() btnDisable: boolean;

	data: SubscriptionEstimate;
	feedback: string;

	private unsubscribe: Subject<void> = new Subject<void>();

	constructor(
		private activeModal: NgbActiveModal,
		private modalService: SNModalService,
		private messageService: MessageService,
		private subscriptionService: NewSubscriptionServiceDataProvider
	) {}

	ngOnInit(): void {
		this.getUnsubscribeMetadata();
	}

	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	cancelSubscription(): void {
		if (!this.feedbackValid()) {
			return;
		}

		this.btnDisable = true;
		this.modalService.setModalData(this.feedback);
	}

	dismiss(): void {
		this.activeModal.dismiss();
	}

	feedbackValid(): boolean {
		const limitValue = 20;
		if (!this.feedback) {
			this.messageService.showToaster(
				'e_3',
				'unsubscribe',
				limitValue.toString()
			);
			return false;
		}

		if (this.feedback) {
			if (!this.feedback.trim()) {
				this.messageService.showToaster(
					'e_3',
					'unsubscribe',
					limitValue.toString()
				);
				return false;
			}

			if (this.feedback.length < limitValue) {
				this.messageService.showToaster(
					'e_3',
					'unsubscribe',
					limitValue.toString()
				);

				return false;
			}
		}

		return true;
	}

	private getUnsubscribeMetadata(): void {
		this.subscriptionService
			.getUnsubscribeTemplateDescription()
			.pipe(takeUntil(this.unsubscribe))
			.subscribe(
				({ data }): SubscriptionEstimate => (this.data = data),
				this.messageService.handleError
			);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/settings/profile/subscription-change/modals/cancel-subscription-confirm/cancel-subscription-confirm-modal.ts